import axios from 'axios';
import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import { ToastContainer, toast } from 'react-toastify';
import { MdOutlineMail, MdOutlinePhoneInTalk } from "react-icons/md";
import { IoLogoInstagram } from "react-icons/io";

import constant from '../../utils/Constant';
import config from '../../config/config';

const {
    VENDOR_DETAILS_END_POINT,
    LOGOUT,
    STATUS_401,
    STATUS_200,
    ONE
} = constant;

const VendorDetails = () => {
    const navigate = useNavigate();

    const [activeImage, setActiveImage] = useState(null);
    const [data, setData] = useState([]);

    // * get token from local storage
    const token = localStorage.getItem('vendor_dashboard');

    // * setting for slider
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    // * execute vendor detaits api
    const executeAllVendorApi = useCallback(async () => {
        try {
            const apiUrl = config.appBaseUrl + VENDOR_DETAILS_END_POINT;

            // * execute get request
            const response = await axios.get(apiUrl, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            // * api response
            const result = response.data;

            // * if response is success
            if (result.code === STATUS_200 && result.status) {
                setData(result.data);
                if (result.data?.vendor_images?.[0]?.image) {
                    setActiveImage(result.data.vendor_images[0].image);
                }
            }
        } catch (error) {
            // * if token is expired
            if (error.response?.data?.code === STATUS_401) {
                navigate(LOGOUT);
            }
            toast.error(error);
        }
    }, [navigate, token]);

    // * execute vendor detaits api
    useEffect(() => {
        executeAllVendorApi();
    }, [executeAllVendorApi, token]);

    const settings1 = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };

    return (
        <>
            <ToastContainer autoClose={700} position='top-center' />
            <div className="page-content px-4">
                <div className="container-fluid">
                    {/* //* start page title */}
                    <div className="row">
                        <div className="col-12 px-0">
                            <div className="page-title-box d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between gap-2">
                                <div className='d-flex align-items-center'>
                                    <h4 className="mb-2 mb-sm-0">Business Details</h4>&nbsp;&nbsp;
                                    <div className='text-muted pointer'>
                                        / &nbsp;<span className=' border px-3 py-2 rounded hover-color-green' onClick={() => navigate('/vendor/update-detail', {
                                            state: {
                                                vendor_id: data.id
                                            }
                                        })}>Update Detail</span>
                                    </div>
                                </div>
                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0 d-flex flex-wrap gap-1">
                                        <li className="breadcrumb-item">
                                            <Link to="/dashboard">Dashboard</Link>
                                        </li>
                                        <li className="breadcrumb-item active">Business Details</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body">

                                <div className="row">
                                    {/* //* left side images */}
                                    <div className="col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-5">
                                        <div className="product-detail">
                                            <div className="row justify-content-center">
                                                {/* //* Main Image */}
                                                <div className="col-12 col-md-12 d-none d-md-block">
                                                    <div className="product-img text-center mb-4">
                                                        <img
                                                            src={activeImage}
                                                            alt="Selected Product"
                                                            className="img-fluid rounded shadow"
                                                            style={{ maxHeight: '300px', minHeight: '300px', objectFit: 'contain' }}
                                                        />
                                                    </div>
                                                </div>

                                                {/* //* Thumbnails (visible on medium and larger screens) */}
                                                <div
                                                    className="col-12 d-none d-md-flex flex-nowrap justify-content-start gap-3 thumbnail-img-width custom-scrollbar"
                                                    style={{ overflowX: 'auto' }}
                                                >
                                                    {data?.vendor_images?.map((img, idx) => (
                                                        <img
                                                            key={idx}
                                                            src={img.image}
                                                            alt={`Thumbnail ${idx + 1}`}
                                                            className={`img-thumbnail tab-img rounded cursor-pointer ${activeImage === img.image ? 'border-golden border-3' : ''}`}
                                                            style={{ width: '80px', height: '80px', objectFit: 'cover', cursor: 'pointer' }}
                                                            onClick={() => setActiveImage(img.image)}
                                                        />
                                                    ))}
                                                </div>


                                                {/* //* Slider (visible only on small screens) */}
                                                <div className="col-12 d-md-none">
                                                    <Slider
                                                        {...settings}
                                                    >
                                                        {data?.vendor_images?.map((img, idx) => (
                                                            <div key={idx} className="text-center">
                                                                <img
                                                                    src={img.image}
                                                                    alt={`Thumbnail ${idx + 1}`}
                                                                    className={`img-thumbnail tab-img rounded cursor-pointer `}
                                                                    style={{ width: '100%', objectFit: 'cover', minHeight: '233px', maxHeight: '233px' }}
                                                                    onClick={() => setActiveImage(img.image)}
                                                                />
                                                            </div>
                                                        ))}
                                                    </Slider>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* //* right side content */}
                                    <div className="col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-7 mt-3 mt-xl-0">
                                        <div className="mt-3 mt-lg-0">
                                            <div className='d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between'>
                                                <div>
                                                    <span className="badge badge-golden-lighten">
                                                        {data?.category == ONE ? 'Mobile Bar' : 'Caterer'}
                                                    </span>
                                                    <div className="d-flex ">
                                                        <h5 className="mt-1 mb-1 font-size-18">{data.name}</h5>
                                                    </div>
                                                    <p className="mt-1">
                                                        {Array.isArray(data?.location) && data.location.join(', ')}
                                                    </p>
                                                </div>
                                                <div>
                                                    <div className="flex items-center gap-2">
                                                        <MdOutlinePhoneInTalk className='me-2' size={18} />
                                                        <span className="text-gray-700 select-none">{data.phone}</span>
                                                    </div>
                                                    <div className="flex items-center gap-2">
                                                        <MdOutlineMail className='me-2' size={18} />
                                                        <span className="text-gray-700 select-none">{data.email}</span>
                                                    </div>
                                                    <div className="flex items-center gap-2">
                                                        <IoLogoInstagram className='me-2' size={18} />
                                                        <span className="text-gray-700 select-none">{data.insta}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr className="mb-4" />
                                            <div className="row">
                                                <div className="col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                                                    <div className=""></div>
                                                    <div>
                                                        <div className="d-flex flex-wrap">
                                                            <div>
                                                                {
                                                                    data.website && (
                                                                        <h5 className="font-size-14 badge badge-golden-lighten ps-0">
                                                                            <Link to={data.website} target='_blank' className='p-1 rounded-2 text-golden'>{data.website}</Link>
                                                                        </h5>
                                                                    )
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <div className='mt-2'>
                                                        <div className="product-color">
                                                            <h5 className="font-size-16">Price Range:</h5>
                                                            <div className="product-color-item mb-3 d-flex align-items-center gap-2">
                                                                <div className="d-inline-block px-2 py-1 bg-light text-dark border rounded">
                                                                    {data?.min}
                                                                </div>
                                                                <span className="font-size-14">to</span>
                                                                <div className="d-inline-block px-2 py-1 bg-light text-dark border rounded">
                                                                    {data?.max}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                </div>

                                                {/* <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-3 mb-sm-0">
                                                    <div className="product-color">
                                                        <h5 className='font-size-16'>Services:</h5>
                                                        <ul style={{ paddingLeft: 17, margin: 0 }}>
                                                            {
                                                                data.vendor_services?.length > ZERO ?
                                                                    data.vendor_services?.map((service, index) => (
                                                                        <li key={index}>{service.service}</li>
                                                                    ))
                                                                    :
                                                                    <span>--</span>
                                                            }
                                                        </ul>
                                                    </div>
                                                </div> */}

                                                {/* <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4">
                                                    <div className="product-color">
                                                        <h5 className='font-size-16'>Tags:</h5>
                                                        <ul style={{ paddingLeft: 17, margin: 0 }}>
                                                            {
                                                                data.vendor_tag?.length > ZERO ?
                                                                    data.vendor_tag?.map((tag, index) => (
                                                                        <li key={index}>{tag.tag}</li>
                                                                    ))
                                                                    :
                                                                    <span>--</span>
                                                            }
                                                        </ul>
                                                    </div>
                                                </div> */}


                                                <div className="col-12">
                                                    <h5 className='font-size-16'>Description:</h5>
                                                    <p>{data?.description}</p>
                                                </div>

                                                <div className="col-12 col-md-12 ps-0">
                                                    <div className="service-carousel-container container mt-2 relative px-0">
                                                        <h5 className='font-size-16 ps-2 mb-0'>Services:</h5>
                                                        <Slider {...settings1}>
                                                            {data.vendor_services?.map((item, idx) => (
                                                                <div key={idx} className="px-2">
                                                                    <div className="card p-2 rounded-lg mb-0 my-3" style={{ background: '#e8ffeb', position: 'relative' }}>
                                                                        <img src={item.image} alt={`Service ${idx + 1}`} className="w-full object-cover mb-2 rounded-lg" style={{ minHeight: '183px', maxHeight: '183px' }} />
                                                                        <div className="card-info flex justify-between items-center">
                                                                            <p className="text-center fw-semibold  mb-0">{item.service_name}</p>
                                                                            {/* <div className="price-border font-bold">R{item.price}</div> */}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </Slider>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default VendorDetails